var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0249 43H39.9749",
    stroke: "currentColor",
    strokeWidth: 4.65278,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0249 33H39.9749",
    stroke: "currentColor",
    strokeWidth: 4.65278,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 23H31.3375C30.5025 23 29.72 22.5825 29.2575 21.8875L25.7425 16.615C25.2775 15.9175 24.4975 15.5 23.6625 15.5H12.5C9.7375 15.5 7.5 17.7375 7.5 20.5V48C7.5 50.7625 9.7375 53 12.5 53H47.5C50.2625 53 52.5 50.7625 52.5 48V28C52.5 25.2375 50.2625 23 47.5 23Z",
    stroke: "currentColor",
    strokeWidth: 4.65278,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 15.5V13C12.4995 10.2375 14.737 8 17.4995 8H42.4995C45.262 8 47.4995 10.2375 47.4995 13V23",
    stroke: "currentColor",
    strokeWidth: 4.65278,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.78227cf092acaf1bbd11352dffba1b29.svg";
export { ForwardRef as ReactComponent };